(function () {
  'use strict';

  angular
    .module('electronicLogBook')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('electronicLogBook', {
        url : '/electronic-log-book',
        views : {        	
        	'electronicLogBookView' : {
        		templateUrl: 'electronic-log-book/views/electronic-log-book.tpl.html',
                controller: 'ElectronicLogBookCtrl',
                controllerAs: 'electronicLogBook'
			}            
        }
      }); 
  }
}());
